/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Start_A_TInputs */

const en_wc_start_a_t = /** @type {(inputs: Wc_Start_A_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start the editor`)
};

/**
* | output |
* | --- |
* | "Start the editor" |
*
* @param {Wc_Start_A_TInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_start_a_t = /** @type {((inputs?: Wc_Start_A_TInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Start_A_TInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_start_a_t(inputs)
});
export { wc_start_a_t as "wc.start.a_t" }